import React from "react";
import {connect, RootStateOrAny} from "react-redux";
import selectors from "../../../../../../redux/selectors";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";
import IWorkflow from "../../../../../../model/interface/dataStorage/workflow/IWorkflow";
import IWorkflowState from "../../../../../../model/interface/dataStorage/workflow/IState";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import Utils from "../../../../../../utils";
import ProSelect from "../../../../../shared/input/ProSelect";

export interface IWorkflowStateFieldOptions {
    contentTypeId?: string,
    onChange?: (value: any, label?: string) => void
}

interface IProps {
    options: IFieldOptions
    findContentTypeBy: (uuid: string) => IContentType
    findWorkflowByContentType: (contentType: IContentType) => IWorkflow
    value?: number | IWorkflowState | string | (number | string | IWorkflowState)[]
    onChange?: (value?: number, label?: string | string[]) => void
    className?: string,
    getText: (code: string, fallback?: string) => string
}

interface IState {
    value?: number | number[]
}

class FormFieldWorkflowState extends React.Component<IProps, IState> {


    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {
            value: Utils.parseObjectToIdentifier(props.value, 'uuid')
        }
    }

    onChange = (value: any) => {
        this.props.options.onChange?.(value)
        const workflow = this.getWorkflow()
        const options = workflow ? this.getSelectOptions(workflow) : []
        const label = Array.isArray(value) ? value.map(v => options.find(i => i.value === v)?.label || '') : (options.find(i => i.value === value)?.label || '')
        this.props.onChange?.(value, value ? label : undefined)
        this.setState({value: value})
    }

    getWorkflow = () => {
        const {options, findWorkflowByContentType, findContentTypeBy} = this.props
        try {
            return options.contentTypeId && findWorkflowByContentType(findContentTypeBy(options.contentTypeId))
        } catch (e) {
            return null
        }
    }

    render() {
        const {options, className} = this.props
        const {value} = this.state
        if (!options.contentTypeId) {
            return (<>Chyba konfigurace</>)
        }

        const workflow = this.getWorkflow()
        if (!workflow){
            return (<>Pro tento typ obsahu neexistuje žádný workflow</>)
        }
        const selectOptions = this.getSelectOptions(workflow);

        return (
            <ProSelect mode={options.multiple ? 'multiple' : undefined} className={className}
                       disabled={options.disabled}
                       allowClear={options.showClear} placeholder={options.placeholder}
                       allowSelectAll={options.allowSelectAll}
                       filterOption={(input, option) =>
                           Utils.stringContains(option?.label, input)
                       }
                       value={value} onChange={this.onChange} options={selectOptions}/>
        )
    }

    getSelectOptions(workflow: IWorkflow) {
        return workflow.activeVersion?.states.map(state => ({
            value: state.uuid!,
            label: this.props.getText(state.name)
        })) || [];
    }
}

const mapStateToProps = (state: RootStateOrAny) => ({
    findContentTypeBy: (uuid: string) => selectors.contentTypes.findOneBy(state, 'uuid', uuid),
    findWorkflowByContentType: (contentType: IContentType) => selectors.workflow.findOneByContentType(state, contentType),
    getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
})

export default connect(mapStateToProps)(FormFieldWorkflowState)